import { render, staticRenderFns } from "./Upgrade.vue?vue&type=template&id=1b121433&"
import script from "./Upgrade.vue?vue&type=script&lang=js&"
export * from "./Upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b121433')) {
      api.createRecord('1b121433', component.options)
    } else {
      api.reload('1b121433', component.options)
    }
    module.hot.accept("./Upgrade.vue?vue&type=template&id=1b121433&", function () {
      api.rerender('1b121433', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/Sections/Upgrade.vue"
export default component.exports